import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import moment from 'moment';
import WorkroomSelect from 'components/formElements/WorkroomSelect';
import SurfaceTypeSelect from 'components/formElements/SurfaceTypeSelect';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import { handleDateSave } from '../../../../../../utils/dateUtils.js';
import reportStyle from 'styles.scss';

class ReportFilters extends React.Component {
  constructor(props) {
    super(props);

    const startingState = {
      workroom_id: parseInt(props.location.query.workroom_id, 10) || null,
      surface_type_id: parseInt(props.location.query.surface_type_id, 10) || null,
      install_date: props.location.query.install_date || moment().format('YYYY-MM-DD'),
      error: '',
    };

    this.state = startingState;
  }

  onWorkroomChange = (selected) => {
    const wrId = selected.length > 0 ? selected[selected.length - 1].value : null;
    this.setState({ workroom_id: wrId || null, error: '' });
  }

  onDateChange = date =>
    this.setState({ install_date: handleDateSave(date) });

  onSurfaceTypeChange = selected =>
    this.setState({ surface_type_id: selected.value || null });

  setError = () =>
    this.setState({ error: 'Please select a workroom' });

  submit = (e) => {
    e.preventDefault();
    if (!this.state.workroom_id) return this.setError();
    const query = { ...this.state };
    delete query.error;
    if (!this.state.surface_type_id) delete query.surface_type_id;

    if (this.props.onSubmit) return this.props.onSubmit(query);

    return this.props.push({ pathname: this.props.location.pathname, query });
  }

  render() {
    const date = moment(this.state.install_date).format('MM/DD/YYYY');
    return (
      <form onSubmit={this.submit} className={reportStyle.form}>
        <WorkroomSelect
          className={reportStyle.formElement}
          multi={false}
          resetValue={null}
          onChange={this.onWorkroomChange}
          value={this.state.workroom_id}
          error={this.state.error}
          required
        />
        <SurfaceTypeSelect
          multi={false}
          className={reportStyle.formElement}
          onChange={this.onSurfaceTypeChange}
          value={this.state.surface_type_id}
          placeholder="All Surfaces"
        />
        <DatePicker
          className={reportStyle.formElement}
          label="Date"
          value={date}
          onChange={this.onDateChange}
          placeholder="Select Date"
          required
        />
        {this.props.children}
        <div className={reportStyle.formBreak} />
        <ColoredButton type="submit">Run Report</ColoredButton>
      </form>
    );
  }
}

ReportFilters.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    query: PropTypes.shape({
      workroom_id: PropTypes.string,
      install_date: PropTypes.string,
      surface_type_id: PropTypes.string,
    }),
  }).isRequired,
  push: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  children: PropTypes.node,
};

export default connect(() => ({}), { push })(ReportFilters);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/components/ReportFilters/index.jsx